<form>
	<div class="row mt-2 align-items-center">
		<div class="col-md-4">
			<strong>{{'iotemeter.load_scheduling.enable_load_scheduling' | translate}}</strong>
		</div>
		<div class="col-md-8">
			<div class="form-check form-check-inline slide-toggle-div">
				<mat-slide-toggle [(ngModel)]="enableLoadSchedule" name="included_in_report"></mat-slide-toggle>
			</div>
		</div>
	</div>

	<table class="w-100 mt-4 table table-striped">
		<thead>
			<tr>
				<th class="col-padding-x">{{ 'iotemeter.load_scheduling.start_time' | translate }}</th>
				<th class="col-padding-x">{{ 'iotemeter.load_scheduling.duration' | translate }}</th>
				<th class="col-padding-x">{{ 'iotemeter.load_scheduling.days' | translate }}</th>
				<th class="col-padding-x">{{ 'g.actions' | translate }}</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let window of schedulingWindows; let i = index">
				<td class="py-2 col-1">
					<div class="d-flex align-items-center">
						<input
							name="window_start_hour_{{i}}"
							[ngClass]="{'is-invalid': window.invalidFields?.hours}"
							type="number"
							class="form-control w-5"
							placeholder="HH"
							[min]="0"
							[max]="24"
							[(ngModel)]="window.hours"
							(ngModelChange)="validateInput(window, 'startHours')"
						/>
						<span>&nbsp;:&nbsp;</span>
						<input
							name="window_start_minute_{{i}}"
							[ngClass]="{'is-invalid': window.invalidFields?.minutes}"
							type="number"
							class="form-control w-5"
							placeholder="MM"
							[min]="0"
							[max]="59"
							[(ngModel)]="window.minutes"
							(ngModelChange)="validateInput(window, 'startMinutes')"
						/>
						<button
							type="button"
							class="btn btn-outline-secondary ml-2"
							value="AM"
							style="width:70px;"
							(click)="window.meridian = (window.meridian === 'AM' ? 'PM' : 'AM')"
						>
							{{ window?.meridian || 'AM' }}
						</button>
					</div>
				</td>
				<td class="py-2 col-1">
					<div class="d-flex align-items-center">
					<input
						name="window_duration_hour_{{i}}"
						[ngClass]="{'is-invalid': window.invalidFields?.durationHours}"
						type="number"
						class="form-control w-5"
						placeholder="HH"
						[min]="0"
						[max]="24"
						[(ngModel)]="window.durationHours"
						(ngModelChange)="validateInput(window, 'durationHours')"

					/>
					<span>&nbsp;:&nbsp;</span>
					<input
						name="window_duration_minute_{{i}}"
						[ngClass]="{'is-invalid': window.invalidFields?.durationMinutes}"
						type="number"
						class="form-control w-5"
						placeholder="MM"
						[min]="0"
						[max]="59"
						[(ngModel)]="window.durationMinutes"
						(ngModelChange)="validateInput(window, 'durationMinutes')"
					/>
					</div>
				</td>
				<td class="py-2 col-1">
					<div [ngClass]="{'is-invalid': window.invalidFields?.days}">
						<ng-select
							name="window_days_mask_{{i}}"
							[ngClass]="{'is-invalid': window.invalidFields?.days}"
							[items]="weekdays"
							bindLabel="label"
							bindValue="id"
							[(ngModel)]="window.selectedDays"
							[multiple]="true"
							[clearable]="false"
							[ngStyle]="{'width': '300px'}"
							placeholder="Select Days"
							(change)="validateInput(window, 'daysMask')"
						></ng-select>
					</div>
				</td>

				<td class="py-2 col-1">
					<button
						class="btn btn-danger rounded-btn btn-sm"
						(click)="removeScheduleWindow(i)"
					>
						{{'g.delete' | translate }}
					</button>
				</td>
			</tr>
		</tbody>
	</table>

	<div class="mt-3 d-flex justify-content-start">
		<button *ngIf="canAddNewWindow()" class="btn btn-primary me-2" (click)="addNewScheduleWindow()">{{ 'iotemeter.load_scheduling.add_window' | translate }}</button>
	</div>

	<div class="mt-2 d-flex justify-content-center">
		<button type="button" class="btn text-white main-blue-bg btn-lg col-4 mr-4" (click)="saveSchedule()">{{'g.save' | translate }}</button>
	</div>
</form>